const digest = '777c5e7119c37ef7003aee20c1387f1287c04c50f7d6abc29167499620c78a04';
const css = `:root{--above_C2C:109000}body,div[data-module-name=axp-hotel-booking-navigation] b,strong{font-family:Helvetica Neue,Helvetica,sans-serif}div[data-module-name=axp-hotel-booking-navigation] div[class*=container]{max-width:unset!important}div[data-module-name=axp-hotel-booking-navigation] div[class*=MobileSubNav] span[class*=programDesc]{padding-left:1.125rem}*{scroll-margin-top:10rem}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default {  };

export { css, digest };